function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3.52c0-1.115.874-2.02 1.952-2.02h10.096C14.126 1.5 15 2.405 15 3.52c0 .934-.611 1.72-1.442 1.952v7.007c0 1.116-.874 2.021-1.952 2.021H4.394c-1.078 0-1.952-.905-1.952-2.02V5.471C1.612 5.24 1 4.454 1 3.521zm2.462 2.022v6.937c0 .533.418.965.932.965h7.212c.514 0 .932-.432.932-.965V5.542H3.462zm-.51-2.986c-.515 0-.932.432-.932.965 0 .533.417.965.932.965h10.096c.515 0 .932-.432.932-.965 0-.533-.417-.965-.932-.965H2.952zM6.048 8a.52.52 0 01.51-.528h2.884a.52.52 0 01.51.528.52.52 0 01-.51.528H6.558A.52.52 0 016.048 8z",
  fill: "#2D2D2D"
});
function SvgArchivo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Archivo.svg";
export { SvgArchivo as ReactComponent };